import {
  EditInventoryItem,
  InventoryFormData,
  InventoryList,
  InventoryListFilter,
  InventoryLogsFilter,
  InventoryManagementList,
  LoadInventoryParams,
  LoadStockControlParams,
  PurchaseOrderDetailFilter,
  PurchaseOrderList,
  PurchaseOrderListItem,
} from "../types/inventory";
import { Product } from "../types/product";
import { get, post } from "./fetch.core";

interface AdjustInventory extends Product {
  inventories: EditInventoryItem[];
}

async function addProduct(data: InventoryFormData) {
  const res = await post<any>("/admin/purchaseOrder/create", { ...data, logType: "warehouseIn" });
  return res.data;
}

async function updateSingleInventoryCount(productId: string, warehouseId: string, data: any) {
  const res = await post<any>(`/admin/inventory/updateSingleCount?productId=${productId}&warehouseId=${warehouseId}`, {
    quantity: data,
  });
  return res.data;
}

async function editInventory(data: any) {
  const res = await post<any>("/admin/inventory/adjustInventory", data);
  return res.data;
}

async function retailAdminUser() {
  const res = await get<{ email: string; _id: string }>(`/admin/inventory/adminUserList`);
  return res.data;
}

async function adjustInventory(productId: string) {
  const res = await get<AdjustInventory>(`/admin/inventory/adjustInventory?productId=${productId}`);
  return res.data;
}

async function productCount(params: Partial<InventoryListFilter>) {
  if (params.warehouseId === "-1") delete params.warehouseId;
  if (params.search === "") delete params.search;
  if (!params.productCategory || params.productCategory.length === 0) delete params.productCategory;
  if (params.date) {
    if (!params.date.from || !params.date.to) delete params.date;
  }
  const response = (await post<InventoryManagementList>("/admin/product/productInventory", params)).data;
  return response;
}

async function loadInventoryManager(params: Partial<InventoryLogsFilter>) {
  if (params.productIds?.length! < 1) delete params.productIds;
  if (!params.warehouseId || params.warehouseId == "-1") delete params.warehouseId;
  if (!params.search) delete params.search;
  if (!params.employeeId) delete params.employeeId;
  if (!params.warehouseId) delete params.warehouseId;

  if (params.date) {
    if (!params.date.from || !params.date.to) delete params.date;
  }
  const response = (await post<InventoryList>("/admin/inventory/listLog", params)).data;
  return response;
}

async function loadStockControl(params: Partial<LoadStockControlParams>) {
  if (params.search === "") delete params.search;
  if (params.warehouseId === "-1") delete params.warehouseId;
  if (params.nameNumberProductSupplier === "") delete params.nameNumberProductSupplier;
  const response = (await post<PurchaseOrderList>("/admin/purchaseOrder/list", params)).data;
  return response;
}

async function editProductControl(params: Partial<PurchaseOrderDetailFilter>) {
  if (!params.arrivalDate) delete params.arrivalDate;
  if (params.orderNumber === "-1") delete params.orderNumber;
  if (params.status === "") return;
  const response = (await post<PurchaseOrderListItem>(`/admin/purchaseOrder/editOrder`, params)).data;

  return response;
}

async function loadSingleStockControl(params: Partial<PurchaseOrderDetailFilter>) {
  if (params.orderNumber === "-1") delete params.orderNumber;
  const response = (await post<PurchaseOrderListItem>(`/admin/purchaseOrder/list?id=${params.id}`, params)).data;

  return response;
}

async function loadSingleInventoryCount(params: Partial<{ id: string }>) {
  const response = (await post<number>(`/admin/inventory/count`, params)).data;

  return response;
}

async function loadInventories(params: Partial<LoadInventoryParams>) {
  if (!params.productCategory || params.productCategory.length == 0) delete params.productCategory;
  if (params.warehouseId === "-1") delete params.warehouseId;
  if (params.date) {
    if (!params.date.from || !params.date.to) delete params.date;
  }

  const response = (await post<InventoryList>("/admin/inventory/listLog", params)).data;
  // console.log("loadInventories", response);

  return response;
}

interface PreprocessAllProductsResponse {
  message: string;
  total: number;
  processed: number;
  errors: Array<{ productId: string; sku: string; error: string }>;
}

async function preprocessAllProducts() {
  const res = await post<PreprocessAllProductsResponse>("/admin/inventory/preprocessAllProducts", {});
  return res.data;
}

const inventoryCore = {
  editProductControl,
  loadInventories,
  editInventory,
  addProduct,
  loadStockControl,
  loadSingleStockControl,
  loadSingleInventoryCount,
  adjustInventory,
  loadInventoryManager,
  retailAdminUser,
  productCount,
  updateSingleInventoryCount,
  preprocessAllProducts,
};

export default inventoryCore;
